import { constants, typographyStyles } from "@newsela/angelou";

import {
  annotationColorsLighter,
  annotationColors,
  annotationColorsDarker,
} from "@/view/AnnotatedText/AnnotatedText.constants";

const { colors } = constants;
const { textSObj } = typographyStyles;

const grey = colors.ui.neutral[500];
const greyDark = colors.ui.neutral[700];

export const radioContainerCss = (color, isSelected) => [
  {
    position: "relative",
    display: "inline-flex",
    height: "70px",
    margin: "0 12px 0 0",

    "input, label:before": {
      boxSizing: "border-box",
      position: "absolute",
      content: '""',
      borderRadius: "inherit",
      height: "40px",
      width: "48px",
      border: "none",
      marginRight: 0,
      borderBottom: `2px solid ${annotationColorsDarker[color]}`,
      backgroundColor: annotationColorsLighter[color],
      transition: "all 0.5s ease",
    },

    "&:hover": {
      "label:before": {
        backgroundColor: annotationColors[color],
      },
      label: {
        fontWeight: isSelected ? null : "bold",
        span: {
          color: greyDark,
        },
      },
    },

    "input:focus-visible + span + label": {
      outline: "-webkit-focus-ring-color",
      outlineStyle: "auto",
      outlineOffset: "4px",
    },

    // Selected radio button
    'input[type="radio"]:checked + span + label:before': {
      backgroundColor: annotationColors[color],
    },
  },
];

export const inputCss = {
  // Hides the native radio button.
  appearance: "hidden",
  opacity: "0.0001",
  zIndex: -1,
  margin: "0",
};

export const labelCss = (isSelected) => [
  {
    display: "inline-flex",
    width: "44px",
    padding: 0,
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",

    // span containing the color's text
    span: {
      ...textSObj,
      position: "relative",
      top: "40px",
      textAlign: "center",
      marginTop: "4px",
      fontWeight: isSelected ? "bold" : "inherit",
      color: isSelected ? greyDark : grey,
    },
  },
];

export const checkIconContainerCss = {
  width: "48px",
  height: "40px",
  position: "absolute",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
};

export const checkIconCss = (color) => [
  {
    position: "absolute",
    width: "26px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    path: {
      stroke: annotationColorsDarker[color],
    },
  },
];
